export default __webpack_public_path__ + "static/machine2-357ea6e2ba28cc5241770c5e05fdd17d.png";